import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { takeReturn } from "@/lib/returnTo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { finishSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const sessionId = match[1];
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        finishSession(res.data.user, res.data.session_token);
        const to = takeReturn();
        window.history.replaceState({}, document.title, to);
        navigate(to, { state: { user: res.data.user } });
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [location.hash, navigate, finishSession]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-teal border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-muted-foreground font-medium">Signing you in…</p>
      </div>
    </div>
  );
}
